import { render, staticRenderFns } from "./PartnerListItem.vue?vue&type=template&id=0ed1c7a9&"
import script from "./PartnerListItem.vue?vue&type=script&lang=js&"
export * from "./PartnerListItem.vue?vue&type=script&lang=js&"
import style0 from "./PartnerListItem.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports